import { createSelector } from 'reselect';

import { SEARCH } from 'constants/FilterConstants';
import { getSelectedDealerGroupId, getSelectedDealerId } from 'selectors/dealerSelectors';
import { getRoot, getProps } from 'utils/selectors';

import { getGateByIds, getUIState } from './core';
import { GATE_STATUS_ENUM } from '../constants';

const getState = createSelector(getUIState, state => state.dashboard);

const getDataState = createSelector(getState, state => state.data);

const getLoadingState = createSelector(getState, state => state.loading);

export const getGateIds = createSelector(getDataState, state => state.ids);

export const getError = createSelector(getDataState, state => state.error);

export const getPage = createSelector(getDataState, state => state.page);

export const hasMore = createSelector(getDataState, state => state.hasMore);

export const isLoading = createSelector(getDataState, state => state.loading);

const getFilters = createSelector(getState, state => state.filters);

export const getSearch = createSelector(getFilters, filters => filters[SEARCH]);

export const getDashboardEntries = createSelector(getRoot, getGateIds, getGateByIds);

export const getAdditionalFilters = createSelector(
  getSelectedDealerId,
  getSelectedDealerGroupId,
  (dealerId, groupId) =>
    ({ groupId, dealerIds: [dealerId] })
);

export const getFormattedFilters = createSelector(
  getAdditionalFilters,
  getFilters,
  getPage,
  (additionalFilters, filters, { size = 10 }) => ({
    ...additionalFilters,
    ...filters,
    status: GATE_STATUS_ENUM.ACTIVE,
    projection: 'details',
    size,
    page: 0,
  })
);

export const isDeleting = createSelector(getLoadingState, getProps, ({ delete: deleteState }, gateId) =>
  deleteState.includes(gateId));
